import moment from 'moment';

const History = class {
  constructor(data) {
    this.data = data;
  }

  get app() {
    return this.data.app;
  }

  get type() {
    return this.data.type;
  }

  get date() {
    return moment(this.data.datetime * 1000);
  }

  static isValid(data) {
    if (typeof data === 'object' && data !== null) {
      return 'app' in data && 'type' && data && 'datetime' in data;
    }
    return false;
  }
};

export default History;



// WEBPACK FOOTER //
// ./src/store/models/history.js